module.exports = __webpack_public_path__ + "img/PT.b27d9cd3.svg";